import React from 'react';

import { Separator } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { FooterLink } from '../components/FooterLink';
import { Headline } from '../components/Headline';
import { HeroFeed } from '../components/HeroFeed';
import { HighAmountConfirmationModal } from '../components/HighAmountConfirmationModal';
import { ImpressionAmountSelector } from '../components/ImpressionAmountSelector';
import { ImpressionCalculation } from '../components/ImpressionCalculation';
import { ImpressionCalculationSubHeader } from '../components/ImpressionCalculationSubHeader';
import { OverwritePaymentMethodConfirmationModal } from '../components/OverwritePaymentMethodConfirmationModal';
import { PaymentMethods } from '../components/PaymentMethods';
import { PolicyInfo } from '../components/PolicyInfo';
import { PublicInput } from '../components/PublicInput';
import { ShouldSavePaymentMethodInput } from '../components/ShouldSavePaymentMethodInput';

import { useButtonBanditPull } from './shared/hooks/useButtonBanditPull';
import { useTrackFormView } from './shared/hooks/useTrackFormView';
import { useTrackPageView } from './shared/hooks/useTrackPageView';

type Props = {
	loadingStartTime: number;
};

export const Layout: React.FC<Props> = ({ loadingStartTime }) => {
	useTrackPageView();

	useButtonBanditPull();

	useTrackFormView(loadingStartTime);

	return (
		<div className="bg-background-overlay h-full md:pt-[50px] md:pb-[100px]">
			<ClientRender>
				{() => (
					<div className="mx-auto w-full md:w-[610px]">
						<div className="rounded-large bg-fill-inverse-strong elevation-low flex flex-col gap-9 px-6 py-7 md:px-10 md:py-9">
							<div className="flex flex-col gap-3">
								<Headline />
								<ImpressionCalculationSubHeader />
							</div>
							<ImpressionAmountSelector />
							<ImpressionCalculation />
							<HeroFeed />
							<Separator className="my-0" />
							<PaymentMethods />
						</div>
						<div className="px-6 py-5 md:px-4 md:py-7">
							<div className="flex flex-col gap-6">
								<div className="flex flex-col gap-4">
									<div className="flex flex-col gap-1">
										<ShouldSavePaymentMethodInput />
										<PublicInput />
									</div>
									<Separator className="my-0" />
									<PolicyInfo />
								</div>
								<Separator className="my-0" />
								<FooterLink />
							</div>
						</div>
						<HighAmountConfirmationModal />
						<OverwritePaymentMethodConfirmationModal />
					</div>
				)}
			</ClientRender>
		</div>
	);
};
